import { General } from "../../../siteManagement/general";
import { Sheet, SheetEventType } from "../../../siteManagement/sheet";
import { AppHelper } from "../../appHelper";
import { Grid } from "../../core/components/grid";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { DialogHelper } from "../../core/util/dialogHelper";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { AppBaseProps, CommonApp, Entity, Metadata } from "../../core/components/commonApp";
import { StyleHelper } from "../../style/style";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react"
export default class EditSendStatus extends React.Component<any, EditSendStatusState>{
    private gridOptions: kendo.ui.GridOptions;


    private translations: StringKeyDictionary<string>;
    private metadata: {};

    constructor(props) {
        super(props);
        this.state = {
            gridData: [],
            deleteEnabel: false
        }
        this.initApp()
    }


    private initApp = async () => {
        let [data, translations, metaData] = await Promise.all([
            this.loadSendStatus(),
            Helper.getTranslations([
                "Standard.Name",
                "Standard.Farbe",
                "WebSMS.GeneralSettings.SendStatus.Sign",
                "Server.Allgemein",
                "WebSMS.GeneralSettings.SendStatus.HasToBeHex",
                "WebSMS.GeneralSettings.Documents.AtLeastOneName",
                "WebSMS.GeneralSettings.SendStatus.HTMLCode",
                "Field.Einsatz.statussend"
            ]),
            Helper.getMetaData("editSendStatus")
        ]);
        this.translations = translations.Data;
        this.gridOptions = {
            sortable: false,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "DisplayName",
                    title: this.translations["Standard.Name"]
                },
                {
                    field: "Color",
                    title: this.translations["Standard.Farbe"],
                    template: "#if(data.Color == null){#<div></div>#} else {#<div class='sendStatusColor' data-color='#=data.Color#'>#=data.Color#</div>#}#"
                },
                {
                    title: this.translations["WebSMS.GeneralSettings.SendStatus.HTMLCode"],
                    field: "Sign",
                    template: "<div class='sendStatusSign' data-sign='#=data.Sign#'></div>",
                    width: 80
                }
            ]
        }
        this.metadata = metaData;
        this.setState({ gridData: data });

    }

    private loadSendStatus = async () => {
        let result = await HTTPService.get<JsonResultClass<SendStatusEntity[]>>('GeneralSettingsLookUp/GetSendStates');
        if (result.Code == 0) {
            return result.Data;
        } else {
            NotificationHelper.showErrorMessage(result.Message);
            return [];
        }
    }
    private selectionChange = (dataItem: SendStatusEntity) => {
        if (Helper.hasValue(dataItem))
            this.setState({ deleteEnabel: dataItem.Id > 3 });
    }
    private createGrid = () => {
        let buttons: Array<ToolBarStandardButton> = [
            {
                type: ToolBarStandardButtonType.NEW,
                caption: Config.translations.newLabel,
                enabled: true
            }, {
                type: ToolBarStandardButtonType.EDIT,
                caption: Config.translations.editLabel,
                enabled: true
            }, {
                type: ToolBarStandardButtonType.DELETE,
                caption: Config.translations.deleteLabel,
                enabled: this.state.deleteEnabel
            }
        ];
        return (
            <div className="flex-container" id="sendStatus">
                <Grid
                    data={this.state.gridData}
                    standardButtons={buttons}
                    options={this.gridOptions}
                    id="sendStatusGrid"
                    onClickStandardButton={this.onStandardButtonClick}
                    onSelectionChanged={this.selectionChange}
                />
            </div>
        );
    }

    private onStandardButtonClick = async (type: ToolBarStandardButtonType, dataItem: SendStatusEntity) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                dataItem = {
                    Color: null,
                    Id: null,
                    IsNew: true,
                    IsWatchable: false,
                    IsWatched: false,
                    Name: {},
                    RecordRight: {
                        CanRead: true,
                        CanWrite: true,
                    },
                    Sign: "",
                    IndividualFields: {}
                };
                this.openSheet(dataItem);
                break;
            case ToolBarStandardButtonType.EDIT:
                this.openSheet(dataItem);
                break;
            case ToolBarStandardButtonType.DELETE:
                const success = await this.delete(dataItem);
                if (success) {
                    const data = await this.loadSendStatus();
                    this.setState({ gridData: data })
                }

                break;
        }
    }

    private openSheet = (dataItem: SendStatusEntity) => {
        const props: SendStatusProps = {
            entity: dataItem,
            onDelete: this.delete,

            context: {
                contextType: 'sendStatus',
            },
            dataSources: null,
            isWindow: false,
            metadata: this.metadata as Metadata,
            title: '',
            validate: this.validate
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, async () => {
            const data = await this.loadSendStatus();
            this.setState({ gridData: data })
        });
        sheet.setTitle(this.translations["Field.Einsatz.statussend"]);
        sheet.show(() => {
            sheet.mountContent(SendStatus, props);
        })
    }

    private validate = (entity: SendStatusEntity) => {
        let isValid = false;
        Object.keys(entity.Name).forEach((language: string) => {
            isValid ||= !Helper.isNullOrEmpty(entity.Name[language]);
        })
        if (!isValid) {
            NotificationHelper.showErrorMessage(this.translations["WebSMS.GeneralSettings.Documents.AtLeastOneName"]);
        }
        return isValid;
    }

    private delete = (dataItem: SendStatusEntity) => {
        return new Promise<boolean>(async (resolve) => {
            const isOK = await DialogHelper.confirm(Config.translations.deleteMessage);
            if (isOK) {
                const result: JsonResultClass = await HTTPService.get<JsonResultClass>("GeneralSettingsLookUp/DeleteSendStatus?id=" + dataItem.Id);
                if (result.Code == 0) {
                    NotificationHelper.showSuccessMessage(result.Message)
                    resolve(true);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            }
            resolve(false);
        })
    }

    private updateGridFields = () => {
        document.querySelectorAll(".sendStatusColor").forEach((element: HTMLDivElement) => {
            let color: string = element.getAttribute("data-color");
            if (!Helper.isNullOrEmpty(color) && color !== "null") {
                if (!color.match(/^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/)) {
                    color = "#FFFFFF";
                }
                element.style.backgroundColor = color;
                element.style.color = StyleHelper.getFontColor(color);
                element.style.height = "25px";
                element.style.padding = "3px 7px";
                element.style.display = "flex";
                element.style.alignItems = "center";
                element.style.justifyContent = "center";
            }
        });


        document.querySelectorAll(".sendStatusSign").forEach((element: HTMLDivElement) => {
            let sign: string = element.getAttribute("data-sign");
            if (!Helper.isNullOrEmpty(sign) && Helper.isHex(sign)) {
                element.innerHTML = `<div>&#x${sign.toUpperCase()};</div>`;
                element.style.display = "flex";
                element.style.alignItems = "center";
                element.style.justifyContent = "center";
                element.style.fontSize = "20px";
            }
        });
    }

    componentDidUpdate() {
        this.updateGridFields();
    }

    componentDidMount() {
        this.updateGridFields();
    }

    render() {
        return Helper.hasValue(this.gridOptions) ? this.createGrid() : null;
    }
}

interface EditSendStatusState {
    gridData: SendStatusEntity[];
    deleteEnabel: boolean;
}

class SendStatus extends React.Component<SendStatusProps, any>{
    common = new AppHelper();
    private sheet: Sheet;
    private preoccupiedIds = {
        0: "WebSMS.GeneralSettings.SendStatus.Unoccupied",
        1: "WebSMS.GeneralSettings.SendStatus.ToSend",
        2: "WebSMS.GeneralSettings.SendStatus.AlreadySend",
        3: "WebSMS.GeneralSettings.SendStatus.Received"
    }


    constructor(props: SendStatusProps) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.sheet = General.Sheet.Manager.getTopMostSheet()
    }

    save = async () => {
        const isValid = this.props.validate(this.props.entity);
        if (isValid) {
            let result = await HTTPService.post<JsonResultClass<number>>("GeneralSettingsLookUp/SaveSendStatus", { model: this.props.entity })
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.props.entity.IsNew = false;
            if (!Helper.hasValue(this.props.entity.Id))
                this.props.entity.Id = result.Data;
            this.common.handlePostSave(result.Code === 0, false);
            this.setState({});
        }
    }

    remove = async () => {
        const success = await this.props.onDelete(this.props.entity);
        if (success) {
            this.sheet.hide();
        }
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    renderInfoLabel = () => {
        if (this.props.entity.Id < 4) {
            let text = Helper.getTranslation("WebSMS.GeneralSettings.SendStatus.InternUse");
            text = text.replace("{x}", Helper.getTranslation(this.preoccupiedIds[this.props.entity.Id]))
            return (
                <div style={{ border: "3px solid #2F96B4", padding: "10px", borderRadius: "5px", borderLeftWidth: "10px", lineHeight: "1.1em", fontSize: "1.1em" }}>
                    {text}
                </div>
            );
        }
        return null;
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

interface SendStatusProps extends AppBaseProps {
    entity: SendStatusEntity;
    onDelete: (entity: SendStatusEntity) => Promise<boolean>;
    validate: (entity: SendStatusEntity) => boolean;
}

interface SendStatusEntity extends Entity {
    Id: number;
    Color: string;
    Sign: string;
    Name: StringKeyDictionary<string>;
}